// extracted by mini-css-extract-plugin
export var container = "_o6-0";
export var dotAnimation = "_o6-2";
export var dotsLoading = "_o6-1";